import { render, staticRenderFns } from "./ParentSelectors.vue?vue&type=template&id=263d7a8c&"
import script from "./ParentSelectors.vue?vue&type=script&lang=ts&"
export * from "./ParentSelectors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports